import { render, staticRenderFns } from "./UgcAssets.vue?vue&type=template&id=0aef6779&"
import script from "./UgcAssets.vue?vue&type=script&lang=js&"
export * from "./UgcAssets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports